'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.directionToComparatorFn = exports.DIRECTION_VALUES = exports.DESCENDING = exports.ASCENDING = exports.sortByDataKeyAndDirection = exports.toggleSortDirection = exports.withSortableRows = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createSortHOC = createSortHOC;

var _ramda = require('ramda');

var _recompose = require('recompose');

var _littleRamda = require('../../little-ramda');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ASCENDING = 'ascending';
var DESCENDING = 'descending';
var DIRECTION_VALUES = [ASCENDING, DESCENDING];
var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

function toggleSortDirection(direction) {
  return direction === ASCENDING ? DESCENDING : ASCENDING;
}

var directionToComparatorFn = function directionToComparatorFn(direction) {
  return direction === ASCENDING ? customAscend : customDescend;
};

var customAscend = (0, _ramda.curry)(function ascend(fn, a, b) {
  var aa = fn(a);
  var bb = fn(b);
  if ((0, _ramda.isNil)(aa)) return 1;else if ((0, _ramda.isNil)(bb)) {
    return -1;
  } else {
    if (typeof aa === "string" && typeof bb === "string") {
      var lowerAA = (0, _ramda.toLower)(aa);
      var lowerBB = (0, _ramda.toLower)(bb);
      return lowerAA < lowerBB ? -1 : lowerAA > lowerBB ? 1 : 0;
    } else {
      return aa < bb ? -1 : aa > bb ? 1 : 0;
    }
  }
});

var customDescend = (0, _ramda.curry)(function descend(fn, a, b) {
  var aa = fn(a);
  var bb = fn(b);
  if ((0, _ramda.isNil)(aa)) {
    return 1;
  } else if ((0, _ramda.isNil)(bb)) {
    return -1;
  } else {
    if (typeof aa === "string" && typeof bb === "string") {
      var lowerAA = (0, _ramda.toLower)(aa);
      var lowerBB = (0, _ramda.toLower)(bb);
      return lowerAA > lowerBB ? -1 : lowerAA < lowerBB ? 1 : 0;
    } else {
      return aa > bb ? -1 : aa < bb ? 1 : 0;
    }
  }
});

var sortByDataKeyAndDirection = function sortByDataKeyAndDirection(sortBy, rows) {
  var comparatorFn = directionToComparatorFn(sortBy[0].direction);
  return (0, _ramda.sortWith)([comparatorFn((0, _ramda.prop)(sortBy[0].key))], rows);
};

function isSortDisabled(columnConfig) {
  return (0, _ramda.propOr)(false, 'disableSort', columnConfig);
}

var enhanceHeaderRenderer = function enhanceHeaderRenderer(sort) {
  return (0, _ramda.unless)(isSortDisabled, (0, _littleRamda.overProp)('headerRenderer', function (renderer) {
    return function (options) {
      return renderer((0, _ramda.merge)(options, { sort: sort }));
    };
  }));
};

/**
 * Accepts initial key and direction, and returns a HOC function
 * @param sortBy
 * @param sortFn
 * @returns {Function}
 */
var withSortableRows = function withSortableRows(_ref) {
  var sortBy = _ref.sortBy,
      _ref$sortFn = _ref.sortFn,
      sortFn = _ref$sortFn === undefined ? sortByDataKeyAndDirection : _ref$sortFn;
  return function (BaseComponent) {
    var hoc = (0, _ramda.compose)((0, _recompose.setPropTypes)({
      columnConfigList: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        headerRenderer: _propTypes2.default.func.isRequired
      })).isRequired,
      rows: _propTypes2.default.array.isRequired
    }), (0, _recompose.withStateHandlers)({ sortBy: sortBy, sortFn: sortFn }, {
      setNewSortBy: function setNewSortBy(state) {
        return function (newSortByKey) {
          var newSortBy = mapIndexed(function (sortByMap, index) {
            if (index === 0) {
              newSortByKey === sortByMap.key ? sortByMap = { key: newSortByKey, direction: toggleSortDirection(state.sortBy[0].direction) } : sortByMap = { key: newSortByKey, direction: state.sortBy[0].direction };
            }
            return sortByMap;
          }, state.sortBy);
          return { sortBy: newSortBy };
        };
      }
    }), (0, _recompose.mapProps)(function (_ref2) {
      var columnConfigList = _ref2.columnConfigList,
          sortBy = _ref2.sortBy,
          setNewSortBy = _ref2.setNewSortBy,
          updateSortState = _ref2.updateSortState,
          rows = _ref2.rows,
          sortFn = _ref2.sortFn,
          rest = _objectWithoutProperties(_ref2, ['columnConfigList', 'sortBy', 'setNewSortBy', 'updateSortState', 'rows', 'sortFn']);

      var sort = {
        key: sortBy[0].key,
        direction: sortBy[0].direction,
        update: setNewSortBy
      };
      return _extends({
        columnConfigList: (0, _ramda.map)(enhanceHeaderRenderer(sort), columnConfigList),
        rows: sortFn(sortBy, rows)
      }, rest);
    }));
    return (0, _recompose.setDisplayName)((0, _recompose.wrapDisplayName)(BaseComponent, 'withSortableRows'))(hoc(BaseComponent));
  };
};

exports.withSortableRows = withSortableRows;
exports.toggleSortDirection = toggleSortDirection;
exports.sortByDataKeyAndDirection = sortByDataKeyAndDirection;
exports.ASCENDING = ASCENDING;
exports.DESCENDING = DESCENDING;
exports.DIRECTION_VALUES = DIRECTION_VALUES;
exports.directionToComparatorFn = directionToComparatorFn;

/**
 * Injects sort prop in columnConfigList[0-XX].headerRenderer function
 * and sorts rows
 * */

function createSortHOC(config) {
  return function withSortHOC(BaseComponent) {
    var SortHOC = function (_React$Component) {
      _inherits(SortHOC, _React$Component);

      function SortHOC(props) {
        _classCallCheck(this, SortHOC);

        var _this = _possibleConstructorReturn(this, (SortHOC.__proto__ || Object.getPrototypeOf(SortHOC)).call(this, props));

        _this.state = {
          sortBy: config.sortBy,
          sortFn: (0, _ramda.defaultTo)(sortByDataKeyAndDirection, config.sortFn),
          columnSortKeyLookup: { fundColumn: config.sortBy[0].key },
          isTopN: false,
          N: 20
        };

        _this.componentWillReceiveProps = function (nextProps) {
          if (nextProps.filteredFundType !== _this.props.filteredFundType || nextProps.activeTableTab !== _this.props.activeTableTab || nextProps.isTopNFundFilterChecked !== _this.state.isTopN) {
            _this.setState({
              sortBy: nextProps.defaultSortBy,
              columnSortKeyLookup: { fundColumn: nextProps.defaultSortBy[0].key },
              isTopN: nextProps.isTopNFundFilterChecked,
              N: nextProps.defaultSortBy[0].topN
            });
          }
        };

        _this.setNewSortBy = function (newSortByKey) {
          var newSortBy = mapIndexed(function (sortByMap, index) {
            if (index === 0) {
              newSortByKey === sortByMap.key ? sortByMap = { key: newSortByKey, direction: toggleSortDirection(_this.state.sortBy[0].direction) } : sortByMap = { key: newSortByKey, direction: _this.state.sortBy[0].direction };
            }
            return sortByMap;
          }, _this.state.sortBy);
          _this.setState({ sortBy: newSortBy });
        };

        _this.setColumnSortKeyAndUpdate = function (columnName, sortKey) {
          _this.setState(function (state) {
            return (0, _ramda.assocPath)(['columnSortKeyLookup', columnName], sortKey, state);
          }, _this.setNewSortBy(sortKey));
        };

        _this.getColumnSortKeyOr = function (defaultValue, columnName) {
          return (0, _ramda.pathOr)(defaultValue, ['columnSortKeyLookup', columnName], _this.state);
        };

        _this.sortRows = function (rows, language) {
          var _this$state = _this.state,
              sortFn = _this$state.sortFn,
              sortBy = _this$state.sortBy,
              isTopN = _this$state.isTopN,
              N = _this$state.N;

          return sortFn(sortBy, rows, language, isTopN, N);
        };

        if (!(0, _ramda.isNil)(props.defaultSortBy)) {
          _this.state['sortBy'] = props.defaultSortBy;
          _this.state['columnSortKeyLookup'] = { fundColumn: props.defaultSortBy[0].key };
          _this.state['isTopN'] = props.isTopNFundFilterChecked;
          _this.state['N'] = props.defaultSortBy ? props.defaultSortBy[0].topN : 20;
        }
        return _this;
      }

      _createClass(SortHOC, [{
        key: 'render',
        value: function render() {
          var _props = this.props,
              children = _props.children,
              rows = _props.rows,
              rest = _objectWithoutProperties(_props, ['children', 'rows']);

          var sort = {
            sortBy: this.state.sortBy,
            update: this.setNewSortBy,
            getColumnSortKeyOr: this.getColumnSortKeyOr,
            setColumnSortKeyAndUpdate: this.setColumnSortKeyAndUpdate
          };

          return _react2.default.createElement(
            BaseComponent,
            _extends({
              rows: this.sortRows(rows, this.props.language),
              sort: sort
            }, rest),
            children
          );
        }
      }]);

      return SortHOC;
    }(_react2.default.Component);

    SortHOC.proptypes = {
      rows: _propTypes2.default.array.isRequired
    };

    return SortHOC;
  };
}